/**
 * 陈文才
 * 定义不支持表格排序的字段(apiname(schemefieldName)或者字段类型(schemefieldType))
 */
export  const sortFidld={
    // 标签字段
    apiname:['cloudcctag'],
    // 文件字段，多选字段类型字段禁止排序
    type:['MR','Q','FL']
}